import { useState } from 'react'
import { useApiClient } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export type ExportType = 'external' | 'internal_with_distance'

export const EXPORT_TYPE_OPTIONS = {
  EXTERNAL: 'external' as ExportType,
  INTERNAL_WITH_DISTANCE: 'internal_with_distance' as ExportType,
}

export type HoursReportsExportParams = {
  contractor?: string
  researchers?: string
  project?: string
  startDate?: string
  endDate?: string
  isExported?: boolean
  exportType?: ExportType
  includeManualHours?: boolean
  includeExpenseDeclarations?: boolean
}

export const useHoursReportsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const exportReport = async ({
    contractor,
    researchers,
    project,
    startDate,
    endDate,
    isExported,
    exportType = EXPORT_TYPE_OPTIONS.EXTERNAL,
    includeManualHours,
    includeExpenseDeclarations,
  }: HoursReportsExportParams) => {
    const queryParams = new URLSearchParams()

    if (contractor) queryParams.append('contractor', contractor)
    if (researchers) queryParams.append('researchers', researchers)
    if (project) queryParams.append('project', project)
    if (startDate) queryParams.append('date_start', startDate)
    if (endDate) queryParams.append('date_end', endDate)
    if (isExported !== undefined && exportType === EXPORT_TYPE_OPTIONS.EXTERNAL)
      queryParams.append('is_exported', isExported ? 'true' : 'false')
    if (includeManualHours) queryParams.append('include_manual_hours', 'true')
    if (includeExpenseDeclarations)
      queryParams.append('include_expense_declarations', 'true')

    setLoading(true)

    try {
      const endpoint =
        exportType === EXPORT_TYPE_OPTIONS.INTERNAL_WITH_DISTANCE
          ? '/hours_reporting/hr/export_with_distance/'
          : '/hours_reporting/hr/export/'

      const response = await client.get<Blob>(
        `${endpoint}?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { exportReport, loading }
}
